import get from 'lodash.get';
import { takeEvery, put, select, take, fork, cancel } from 'redux-saga/effects';
import { LOCATION_CHANGE } from 'react-router-redux';
import { LOGOUT } from './auth';
import { STUDENT_VIEW } from './app';
import { SET_ME } from './me';
import SPARTAN_USER_TYPES from '../../constants/spartan-user-types';

const CHANGE_LOCK_STATUS = 'lock/CHANGE_LOCK_STATUS';


const lockReducer = (state = false, action) => {
    switch (action.type) {
        case CHANGE_LOCK_STATUS:
            return action.payload;
        default:
            return state;
    }
};


export default lockReducer;

export const changeLockStatusAction = payload => ({
    type: CHANGE_LOCK_STATUS,
    payload,
});

export function* rootSaga() {
    yield [
        takeEvery(SET_ME, initLockState),
        takeEvery(LOCATION_CHANGE, unlockOnLocationChange),
    ];
}

export function* initLockState() {
    const { theme, me, users } = yield select();
    if (!theme.connectMode) {
        return;
    }
    const userId = me.userId;
    const {
        interestsCompleted,
        valuesCompleted,
    } = get(users, `list.${userId}`, {});

    const completed = (
        interestsCompleted &&
        valuesCompleted
    );

    if (completed) {
        return;
    }

    yield put(changeLockStatusAction(true));
}


export function* unlockOnLocationChange() {
    const { theme, app, router, lock, me } = yield select();

    if (!theme.connectMode || app.view !== STUDENT_VIEW || !lock) {
        return;
    }
    const pathname = get(router, 'location.pathname', '/');

    if (theme.companyDomain === 'spartan' && me.spartanUserType === SPARTAN_USER_TYPES.ON_CAMPUS_VISIT) {
        if (pathname.indexOf('/career-matches') === -1) {
            return;
        }
    } else if (pathname !== '/colleges') {
        return;
    }


    const task = yield fork(lockWhenVisitResultsPage);

    yield take(LOGOUT);

    yield cancel(task);
}

export function* lockWhenVisitResultsPage() {
    while (true) { // eslint-disable-line no-constant-condition
        const action = yield take(LOCATION_CHANGE);
        if (action.payload.pathname === '/results') {
            yield put(changeLockStatusAction(false));
            break;
        }
    }
}



// WEBPACK FOOTER //
// ./src/client/redux/lock.js